import makeUrl from "core/helpers/url/makeUrl";

const findUrl = (record, landingUrls) => landingUrls.find(url => url.domainId === record.domainId && url.landingId === record.landingId)

export const getTableColumns = additionalProps => {

    const { landingUrls } = additionalProps;

    return [
        {
            title: "backoffice.campaigns.domain",
            dataIndex: "domain",
            mobileLevel: 1,
            render: (_, record) => findUrl(record, landingUrls)?.domain ?? ""
        },
        {
            title: "backoffice.campaigns.landingName",
            dataIndex: "landingName",
            mobileLevel: 2,
            render: (_, record) => findUrl(record, landingUrls)?.landingName ?? ""
        },

        {
            title: "backoffice.campaigns.url",
            dataIndex: "url",
            mobileLevel: 3,
            render: (_, record) => {
                const url = findUrl(record, landingUrls);
                if(!url) return "";
                const value = makeUrl(url.domain, url.subdomain, url.relative);
                return (
                    <span 
                        className="rt--title rt--font-normal rt--font-regular rt--table-col-link"
                        onClick={() => window.open( value,"_blank")}
                    >
                        <b>{ value }</b>
                    </span>
                )
            }
        }
    ]
}
